/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    IntegrationFieldExistent,
    instanceOfIntegrationFieldExistent,
    IntegrationFieldExistentFromJSON,
    IntegrationFieldExistentFromJSONTyped,
    IntegrationFieldExistentToJSON,
} from './IntegrationFieldExistent';
import {
    IntegrationFieldMapping,
    instanceOfIntegrationFieldMapping,
    IntegrationFieldMappingFromJSON,
    IntegrationFieldMappingFromJSONTyped,
    IntegrationFieldMappingToJSON,
} from './IntegrationFieldMapping';

/**
 * @type IntegrationField
 * 
 * @export
 */
export type IntegrationField = IntegrationFieldExistent | IntegrationFieldMapping;

export function IntegrationFieldFromJSON(json: any): IntegrationField {
    return IntegrationFieldFromJSONTyped(json, false);
}

export function IntegrationFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...IntegrationFieldExistentFromJSONTyped(json, true), ...IntegrationFieldMappingFromJSONTyped(json, true) };
}

export function IntegrationFieldToJSON(value?: IntegrationField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfIntegrationFieldExistent(value)) {
        return IntegrationFieldExistentToJSON(value as IntegrationFieldExistent);
    }
    if (instanceOfIntegrationFieldMapping(value)) {
        return IntegrationFieldMappingToJSON(value as IntegrationFieldMapping);
    }

    return {};
}

